import React, { useEffect, useMemo, useRef, useState } from 'react';
import { LayoutGrid } from 'lucide-react';

const CustomButtonDropdown = ({
  buttons = [],
  placeOnPage,
  onButtonClick,
  className = '',
  inDetailsLabel = 'Custom Button'
}) => {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const normalizedPlace = String(placeOnPage || '').trim().toLowerCase();

  const filteredButtons = useMemo(() => {
    return (buttons || []).filter(
      (item) => String(item?.PlaceOnPage || '').trim().toLowerCase() === normalizedPlace
    );
  }, [buttons, normalizedPlace]);

  useEffect(() => {
    const onDocClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', onDocClick);
    }

    return () => {
      document.removeEventListener('mousedown', onDocClick);
    };
  }, [open]);

  if (!filteredButtons.length) return null;

  const imageWidth = normalizedPlace === 'inlist' ? '36px' : normalizedPlace === 'indetails' ? '18px' : '14px';
  const buttonTitle = normalizedPlace === 'indetails' ? inDetailsLabel : 'Custom Button';

  return (
    <div className={`relative ${className}`} ref={menuRef}>
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className="p-1 rounded hover:bg-gray-100 transition"
        title={buttonTitle}
      >
        <LayoutGrid size={imageWidth === '36px' ? 24 : imageWidth === '18px' ? 18 : 14} className="text-slate-500" />
      </button>

      {open && (
        <div className="absolute right-0 top-full mt-1 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-72 overflow-y-auto">
          <div className="py-1">
            {filteredButtons.map((button) => (
              <button
                type="button"
                key={String(button?.ButtonId || button?.ButtonName)}
                className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"
                onClick={async (event) => {
                  event.stopPropagation();
                  setOpen(false);
                  if (typeof onButtonClick === 'function') {
                    await onButtonClick(button);
                  }
                }}
              >
                {button?.ButtonName || 'Unnamed Button'}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomButtonDropdown;
